<template>
  <div class="container page-section mt-3 mt-md-5">
    <div class="col-12">
      <div class="row">
        <div class="col-md-7">
          <div class="col-md-10">
            <div>
              <div v-if="step === 1">
                <div class="row">
                  <div class="col-md-12 my-2">
                    <h3>{{ $t('form.purchasing.label.personal_information') }}</h3>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <p class="label-subtitle">
                      {{ $t('form.borrow.subtitle') }}
                    </p>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.firstName') }}</label>
                      <input
                        name="name"
                        type="text"
                        class="form-control form-input"
                        v-model="data.name"
                        :class="messageValidate && messageValidate.hasOwnProperty('name') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.firstName')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('name')"
                      >
                        {{ messageErrorLabels.name }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.lastName') }}</label>
                      <input
                        name="name"
                        type="text"
                        class="form-control form-input"
                        v-model="data.last_name"
                        :class="messageValidate && messageValidate.hasOwnProperty('last_name') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.lastName')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('last_name')"
                      >
                        {{ messageErrorLabels.last_name }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.phone') }}</label>
                      <input
                        type="tel"
                        name="phone_number"
                        v-mask="'0## ### ####'"
                        class="form-control form-input"
                        v-model="data.phone"
                        :class="messageValidate && messageValidate.hasOwnProperty('phone') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.phone')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('phone')"
                      >
                        {{ messageErrorLabels.phone }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.email') }}</label>
                      <input
                        type="email"
                        name="email"
                        class="form-control form-input"
                        v-model="data.email"
                        :class="messageValidate && messageValidate.hasOwnProperty('email') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.email')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('email')"
                      >
                        {{ messageErrorLabels.email }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">
                        {{ $t('form.purchase.label.amount_request') }} ($)
                      </label>
                      <select
                        v-model="data.amountBorrow"
                        class="form-control form-input"
                      >
                        <option
                          value=""
                          disabled
                          selected
                        >
                          {{ $t("form.select.label.amountBorrow") }}
                        </option>
                        <template v-if="pawnLoanAmountRange.length > 0">
                          <option
                            v-for="(amount, key) in pawnLoanAmountRange"
                            :value="amount"
                            :key="key"
                          >
                            $ {{ amount }}
                          </option>
                        </template>
                      </select>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('amount')"
                      >
                        {{ messageErrorLabels.amount }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">
                        {{ $t('form.pawn.label.loan_terms') }}
                      </label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="data.amountDate"
                            class="form-control form-input"
                          >
                            <option
                              value=""
                              disabled
                              selected
                            >
                              {{ $t("form.pawn.label.loan_terms_select") }}
                            </option>
                            <template v-if="pawnDurationRange.length > 0">
                              <template v-for="(item, key) in pawnDurationRange">
                                <option
                                  :value="item"
                                  :key="key"
                                >
                                  {{ item }} {{ $t('calender.month') }}
                                </option>
                              </template>
                            </template>
                          </select>
                        </div>
                      </div>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('duration')"
                      >
                        {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">
                        {{ $t('form.pawn.label.type_of_collateral') }}
                      </label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="typeOfCollateral"
                            class="form-control form-input"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.pawn.label.type_of_collateral_select") }}
                            </option>
                            <template v-for="(item, key) in typeOfCollateralOptions">
                              <option
                                :value="item.value"
                                :key="key"
                              >
                                {{ $t(item['label_' + $i18n.locale]) }}
                              </option>
                            </template>
                          </select>
                        </div>
                        <div
                          v-if="typeOfCollateral === 'Other'"
                          class="col-md-12 pt-2 pb-2"
                        >
                          <input
                            type="text"
                            class="form-control form-input"
                            :placeholder="$t('borrow.placeholder.otherValue')"
                            v-model="typeOfCollateralOtherValue"
                          >
                        </div>
                      </div>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('type_of_collateral')"
                      >
                        {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <button
                      class="default-button float-right"
                      @click="submitFormTabInfo('pawn_choose_product_type')"
                    >
                      {{ $t('button.next') }}
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="step === 2">
                <div class="row">
                  <div class="col-md-12 my-2">
                    <h3>{{ $t('form.purchasing.label.personal_information') }}</h3>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label>{{ $t('form.borrow.id_number') }}</label>
                      <input
                        type="text"
                        name="national_id"
                        class="form-control form-input"
                        v-mask="'#########'"
                        v-model="IDNumber"
                        :class="messageValidate && messageValidate.hasOwnProperty('national_id_number') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.ID')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('national_id_number')"
                      >
                        {{ messageErrorLabels.national_id_number }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.dob') }}</label>
                      <date-picker
                        v-model="dateOfBirth"
                        placeholder="DD/MM/YYYY"
                        :class="messageValidate && messageValidate.hasOwnProperty('date_of_birth') ? 'form-control form-input form-input-error': 'form-control form-input'"
                        :config="options"
                      />
                      <span
                        v-show="dateOfBirthError"
                        class="label-error"
                      >{{ $t('borrow.yearForborrow') }}</span>
                      <span
                        v-show="!dateOfBirthError"
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('date_of_birth')"
                      >
                        {{ messageErrorLabels.date_of_birth }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.gender.label') }}</label>
                      <div class="row">
                        <div class="col-md-3 pt-2 pb-2">
                          <div class="custom-control custom-radio">
                            <input
                              v-model="gender"
                              class="custom-control-input"
                              type="radio"
                              name="gender"
                              id="male"
                              value="Male"
                            >
                            <label
                              class="custom-control-label"
                              for="male"
                            >{{ $t('form.borrow.gender.male') }}</label>
                          </div>
                        </div>
                        <div class="col-md-3 pt-2 pb-2">
                          <div class="custom-control custom-radio">
                            <input
                              v-model="gender"
                              class="custom-control-input"
                              type="radio"
                              name="gender"
                              id="female"
                              value="Female"
                            >
                            <label
                              class="custom-control-label"
                              for="female"
                            >{{ $t('form.borrow.gender.female') }}</label>
                          </div>
                        </div>
                      </div>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('gender')"
                      >
                        {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                      </span>
                    </div>
                  </div>

                  <!--2-03 Marital status not done-->
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.maritalStatus.label') }}</label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="maritalStatus"
                            class="form-control form-input"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.select.label.maritalStatus") }}
                            </option>
                            <template v-for="(maritalStatusOption, key) in maritalStatusOptions">
                              <option
                                :value="maritalStatusOption.value"
                                :key="key"
                              >
                                {{ $t(maritalStatusOption.label) }}
                              </option>
                            </template>
                          </select>
                        </div>
                      </div>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('marital_status')"
                      >
                        {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                      </span>
                    </div>
                  </div>

                  <div class="col-md-6 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.home') }}</label>
                      <input
                        type="text"
                        name="homeNumber"
                        class="form-control form-input"
                        v-model="homeNumber"
                        :class="messageValidate && messageValidate.hasOwnProperty('home_number') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.homeNumber')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('home_number')"
                      >
                        {{ messageErrorLabels.home_number }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.street') }}</label>
                      <input
                        type="text"
                        name="streetNumber"
                        class="form-control form-input"
                        v-model="streetNumber"
                        :class="messageValidate && messageValidate.hasOwnProperty('street_number') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.streetNumber')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('street_number')"
                      >
                        {{ messageErrorLabels.street_number }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.province') }}</label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="province"
                            class="form-control form-input"
                            @change="getDistrict"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.select.label.province") }}
                            </option>
                            <template
                              v-if="$i18n.locale === 'km'"
                            >
                              <option
                                :value="item"
                                v-for="(item, key) in nameProvinceOptions"
                                :key="key"
                              >
                                {{ item.name_km }}
                              </option>
                            </template>
                            <template
                              v-if="$i18n.locale === 'en'"
                            >
                              <option
                                :value="item"
                                v-for="(item, key) in nameProvinceOptions"
                                :key="key"
                              >
                                {{ item.name_latin }}
                              </option>
                            </template>
                          </select>
                          <span
                            class="label-error"
                            v-if="messageValidate && messageValidate.hasOwnProperty('province')"
                          >
                            {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="province"
                    class="col-md-12 mt-2 mb-2"
                  >
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.district') }}</label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="district"
                            class="form-control form-input"
                            @change="getCommune"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.select.label.district") }}
                            </option>
                            <template
                              v-if="$i18n.locale === 'km'"
                            >
                              <option
                                :value="item"
                                v-for="(item, key) in nameDistrictOptions"
                                :key="key"
                              >
                                {{ item.name_km }}
                              </option>
                            </template>
                            <template
                              v-if="$i18n.locale === 'en'"
                            >
                              <option
                                :value="item"
                                v-for="(item, key) in nameDistrictOptions"
                                :key="key"
                              >
                                {{ item.name_latin }}
                              </option>
                            </template>
                          </select>
                          <span
                            class="label-error"
                            v-if="messageValidate && messageValidate.hasOwnProperty('district')"
                          >
                            {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="district"
                    class="col-md-12 mt-2 mb-2"
                  >
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.commune') }}</label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="commune"
                            class="form-control form-input"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.select.label.commune") }}
                            </option>
                            <template
                              v-if="$i18n.locale === 'km'"
                            >
                              <option
                                :value="item"
                                v-for="(item, key) in nameCommuneOptions"
                                :key="key"
                              >
                                {{ item.name_km }}
                              </option>
                            </template>
                            <template
                              v-if="$i18n.locale === 'en'"
                            >
                              <option
                                :value="item"
                                v-for="(item, key) in nameCommuneOptions"
                                :key="key"
                              >
                                {{ item.name_latin }}
                              </option>
                            </template>
                          </select>
                          <span
                            class="label-error"
                            v-if="messageValidate && messageValidate.hasOwnProperty('commune')"
                          >
                            {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('field.label.home_type') }}</label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="home_type"
                            class="form-control form-input"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("field.label.home_type") }}
                            </option>
                            <template v-for="(homeType, key) in homeTypes">
                              <option
                                :value="homeType.value"
                                :key="key"
                              >
                                {{ homeType['name_' + $i18n.locale] }}
                              </option>
                            </template>
                          </select>
                          <span
                            class="label-error"
                            v-if="messageValidate && messageValidate.hasOwnProperty('home_type')"
                          >
                            {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <button
                      class="default-button"
                      @click="prev"
                    >
                      {{ $t('button.previous') }}
                    </button>
                    <button
                      class="default-button float-right"
                      @click="submitFormTabInfo('pawn_personal_information')"
                    >
                      {{ $t('button.next') }}
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="step === 3">
                <div class="row">
                  <div class="col-md-12 mt-2 mb-2">
                    <h3>{{ $t('form.borrow.label.employment_detail') }}</h3>
                    <P class="label-subtitle">
                      {{ $t('form.borrow.string.first_info') }}
                    </P>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label>{{ $t('form.borrow.occupation') }}</label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="occupation"
                            class="form-control form-input"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.select.label.occupation") }}
                            </option>
                            <template v-for="(occupationOption, key) in occupationOptions">
                              <option
                                :value="occupationOption.value"
                                :key="key"
                              >
                                {{ $t(occupationOption.label) }}
                              </option>
                            </template>
                          </select>
                        </div>
                      </div>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('occupation')"
                      >
                        {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label>{{ $t('form.borrow.name_of_company') }}</label>

                      <input
                        name="nameCompany"
                        type="text"
                        class="form-control form-input"
                        v-model="nameCompany"
                        :class="messageValidate && messageValidate.hasOwnProperty('company_name') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.name_of_company')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('company_name')"
                      >
                        {{ messageErrorLabels.company_name }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label>{{ $t('form.borrow.monthly_income') }}</label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="monthlyIncome"
                            class="form-control form-input"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.select.label.monthlyIncome") }}
                            </option>
                            <template v-for="(monthlyIncomeOption, key) in monthlyIncomeOptions">
                              <option
                                :value="monthlyIncomeOption.value"
                                :key="key"
                              >
                                {{ monthlyIncomeOption.label }}
                              </option>
                            </template>
                          </select>
                        </div>
                      </div>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('gross_monthly_income')"
                      >
                        {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="form-label">{{ $t('form.borrow.company_contact_name') }}</label>
                      <input
                        name="companyContactName"
                        type="text"
                        class="form-control form-input"
                        v-model="companyContactName"
                        :class="messageValidate && messageValidate.hasOwnProperty('company_contact_name') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.company_contact_name')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('company_contact_name')"
                      >
                        {{ messageErrorLabels.company_contact_name }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label>{{ $t('form.borrow.telephone') }}</label>
                      <input
                        name="telephone"
                        type="tel"
                        class="form-control form-input"
                        v-model="companyContactPhone"
                        v-mask="'0## ### ####'"
                        :class="messageValidate && messageValidate.hasOwnProperty('company_contact_phone') ? 'form-input-error': '' "
                        :placeholder="$t('borrow.placeholder.phone')"
                      >
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('company_contact_phone')"
                      >
                        {{ messageErrorLabels.company_contact_phone }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <button
                      class="default-button"
                      @click="prev"
                    >
                      {{ $t('button.previous') }}
                    </button>
                    <button
                      class="default-button float-right"
                      @click="submitFormTabInfo('pawn_employment_info')"
                    >
                      {{ $t('button.next') }}
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="step === 4">
                <div class="row">
                  <div class="col-md-12 mt-2 mb-2">
                    <h3>{{ $t('form.borrow.label.guarantor_detail') }}</h3>
                    <P class="label-subtitle">
                      {{ $t('form.pawn.string.guarantor_info') }}
                    </P>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.pawn.string.having_guarantor') }}</label>
                      <div class="row">
                        <div class="col-md-3 pt-2 pb-2">
                          <div class="custom-control custom-radio">
                            <input
                              v-model="havingGuarantor"
                              class="custom-control-input"
                              type="radio"
                              name="have_guarantor"
                              id="yes"
                              value="Yes"
                            >
                            <label
                              class="custom-control-label"
                              for="yes"
                            >
                              {{ $t('form.pawn.guarantor.yes') }}
                            </label>
                          </div>
                        </div>
                        <div class="col-md-3 pt-2 pb-2">
                          <div class="custom-control custom-radio">
                            <input
                              v-model="havingGuarantor"
                              class="custom-control-input"
                              type="radio"
                              name="have_guarantor"
                              id="no"
                              value="no"
                            >
                            <label
                              class="custom-control-label"
                              for="no"
                            >
                              {{ $t('form.pawn.guarantor.no') }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <template v-if="havingGuarantor === 'Yes'">
                    <div class="col-md-12 mt-2 mb-2">
                      <div class="form-group">
                        <label>{{ $t('form.borrow.guarantor.name') }}</label>
                        <input
                          name="relativesName"
                          type="text"
                          class="form-control form-input"
                          v-model="relativesName"
                          :class="messageValidate && messageValidate.hasOwnProperty('relative_name') ? 'form-input-error': '' "
                          :placeholder="$t('borrow.placeholder.name')"
                        >
                        <span
                          class="label-error"
                          v-if="messageValidate && messageValidate.hasOwnProperty('relative_name')"
                        >
                          {{ messageErrorLabels.relative_name }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2 mb-2">
                      <div class="form-group">
                        <label>{{ $t('form.borrow.guarantor.contact') }}</label>
                        <input
                          name="relativesContact"
                          type="tel"
                          class="form-control form-input"
                          v-mask="'0## ### ####'"
                          v-model="relativesContact"
                          :class="messageValidate && messageValidate.hasOwnProperty('relative_contact_phone') ? 'form-input-error': '' "
                          :placeholder="$t('borrow.placeholder.phone')"
                        >
                        <span
                          class="label-error"
                          v-if="messageValidate && messageValidate.hasOwnProperty('relative_contact_phone')"
                        >
                          {{ messageErrorLabels.relative_contact_phone }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <div class="col-md-12 mt-2 mb-2">
                    <button
                      class="default-button"
                      @click="prev"
                    >
                      {{ $t('button.previous') }}
                    </button>
                    <button
                      class="default-button float-right"
                      @click="submitFormTabInfo('pawn_relatives_info')"
                    >
                      {{ $t('button.next') }}
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="step === 5">
                <div class="row">
                  <div class="col-md-12 mt-2 mb-2">
                    <h3>{{ $t('form.borrow.label.relative_detail') }}</h3>
                    <P class="label-subtitle">
                      {{ $t('form.borrow.string.second_info') }}
                    </P>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">{{ $t('form.borrow.string.photo') }}</label>
                      <b-form-file
                        v-model="photo"
                        :browse-text="$t('string.picture_or_camera')"
                        :placeholder="$t('string.choose_a_file')"
                        drop-placeholder="Drop file here..."
                        accept="image/*"
                        capture
                      />
                      <p
                        class="mt-2"
                        v-if="photo && photo.name"
                      >
                        {{ $t('string.selected_file') }}: <b>{{ photo.name }}</b>
                      </p>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('borrower_photo')"
                      >
                        {{ photo ? messageValidate.borrower_photo[0] : messageErrorLabels.borrower_photo }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label>{{ $t('form.borrow.string.nationalIdPhoto') }}</label>
                      <b-form-file
                        v-model="nationalIdPhoto"
                        :browse-text="$t('string.picture_or_camera')"
                        :placeholder="$t('string.choose_a_file')"
                        drop-placeholder="Drop file here..."
                        accept="image/*"
                        capture
                      />
                      <p
                        class="mt-2"
                        v-if="nationalIdPhoto && nationalIdPhoto.name"
                      >
                        {{ $t('string.selected_file') }}: <b>{{ nationalIdPhoto.name }}</b>
                      </p>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('borrower_national_id_photo')"
                      >
                        {{ nationalIdPhoto ? messageValidate.borrower_national_id_photo[0] : messageErrorLabels.borrower_national_id_photo }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label>{{ $t('form.borrow.string.employment_photo') }}</label>
                      <b-form-file
                        v-model="employeeCardPhoto"
                        :browse-text="$t('string.picture_or_camera')"
                        :placeholder="$t('string.choose_a_file')"
                        drop-placeholder="Drop file here..."
                        accept="image/*"
                        capture
                      />
                      <p
                        class="mt-2"
                        v-if="employeeCardPhoto && employeeCardPhoto.name"
                      >
                        {{ $t('string.selected_file') }}: <b>{{ employeeCardPhoto.name }}</b>
                      </p>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('borrower_employment_card_photo')"
                      >
                        {{ employeeCardPhoto ? messageValidate.borrower_employment_card_photo[0] : messageErrorLabels.borrower_employment_card_photo }}
                      </span>
                      <div class="mt-4">
                        <label>{{ $t('label.photo_Instruction') }}</label>
                        <ul>
                          <li class="my-2">
                            {{ $t('label.photo_Instruction_1') }}
                          </li>
                          <li class="my-2">
                            {{ $t('label.photo_Instruction_2') }}
                          </li>
                          <li class="my-2">
                            {{ $t('label.photo_Instruction_3') }}
                          </li>
                          <li class="my-2">
                            {{ $t('label.photo_Instruction_4') }}
                          </li>
                          <li class="my-2">
                            {{ $t('label.photo_Instruction_5') }}
                          </li>
                        </ul>
                      </div>
                      <img
                        src="/img/take_photo_with_id.jpg"
                        alt="sample picture"
                        class="sample-picture"
                      >
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="form-group">
                      <label class="label-required">
                        {{ $t('form.borrow.howDidYouHearAboutUs?') }}
                      </label>
                      <div class="row">
                        <div class="col-md-12 pt-2 pb-2">
                          <select
                            v-model="sourceOfInformation"
                            class="form-control form-input"
                          >
                            <option
                              :value="null"
                              disabled
                              selected
                            >
                              {{ $t("form.borrow.howDidYouHearAboutUs?") }}
                            </option>
                            <template v-for="(item, key) in sourceOfInformationOptions">
                              <option
                                :value="item.value"
                                :key="key"
                              >
                                {{ $t(item.label) }}
                              </option>
                            </template>
                          </select>
                        </div>
                        <div
                          v-if="sourceOfInformation === 'Other'"
                          class="col-md-12 pt-2 pb-2"
                        >
                          <input
                            type="text"
                            class="form-control form-input"
                            :placeholder="$t('borrow.placeholder.otherValue')"
                            v-model="sourceOfInformationOtherValue"
                          >
                        </div>
                      </div>
                      <span
                        class="label-error"
                        v-if="messageValidate && messageValidate.hasOwnProperty('source_of_information')"
                      >
                        {{ $t('messageError.label.pleaseSelectOneOptionAbove') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 mt-2 mb-2">
                    <button
                      class="default-button"
                      @click="prev"
                    >
                      {{ $t('button.previous') }}
                    </button>
                    <button
                      class="default-button float-right"
                      @click="submitFormTabInfo('pawn_document_verification')"
                    >
                      {{ $t('button.submit') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 block-img-purchase d-none d-md-block">
          <img
            src="/img/cashHero_2.png"
            alt="cashHero_2.png"
            class="img-size"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { dataOptions } from '../form/dataOptions'

export default {
  name: 'PawnForm',
  metaInfo () {
    return {
      title: 'Pawn Form',
      titleTemplate: '%s | CashHero',
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'CashHero Pawn Form' }
      ]
    }
  },
  computed: Object.assign(mapState({
    data: state => state.borrow
  }), {
    dateOfBirthError () {
      if (this.dateOfBirth) {
        const changeFormat = this.$moment(this.dateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const age = this.$moment().diff(changeFormat, 'years', false)
        if (age >= 18 && age <= 50) {
          this.messageValidateAge = false
          return false
        } else {
          this.messageValidateAge = true
          return true
        }
      } else {
        this.messageValidateAge = false
        return false
      }
    },
    pawnLoanAmountRange () {
      const pawnAmountRange = new Array(Math.floor(((this.pawnData.amount.max - this.pawnData.amount.min) / this.pawnData.amount.interval) + 1)).fill().map((_, index) => this.pawnData.amount.min + (index * this.pawnData.amount.interval))
      if (!(pawnAmountRange.includes(this.pawnData.amount.max))) {
        pawnAmountRange.push(this.pawnData.amount.max)
      }
      return pawnAmountRange
    },
    pawnDurationRange () {
      return new Array(Math.floor(((this.pawnData.duration.max - this.pawnData.duration.min) / this.pawnData.duration.interval) + 1)).fill().map((_, index) => this.pawnData.duration.min + (index * this.pawnData.duration.interval))
    }
  }),
  data () {
    return {
      step: 1,
      id: null,
      status: 'Draft',
      baseUrl: process.env.VUE_APP_BASE_URL,
      loanType: 'Pawn',
      options: {
        format: 'DD/MM/YYYY',
        useCurrent: false
      },

      typeOfCollateral: null,
      typeOfCollateralOtherValue: null,

      dateOfBirth: null,
      IDNumber: null,
      gender: null,
      maritalStatus: null,
      homeNumber: null,
      streetNumber: null,
      messageValidate: null,
      commune: null,
      district: null,
      province: null,
      home_type: null,
      selectedPurchaseItem: null,
      selectedPurchaseItemOther: null,
      purchaseItemPrice: null,

      occupation: null,
      nameCompany: null,
      monthlyIncome: null,
      occupationOtherValue: null,
      companyContactName: null,
      companyContactPhone: null,

      havingGuarantor: 'no',
      relativesName: null,
      relativesContact: null,

      photo: [],
      nationalIdPhoto: [],
      employeeCardPhoto: [],
      sourceOfInformation: null,
      sourceOfInformationOtherValue: '',

      pawnData: dataOptions.pawn,
      typeOfCollateralOptions: dataOptions.typeOfCollateralOptions,
      maritalStatusOptions: dataOptions.maritalStatusOptions,
      sourceOfInformationOptions: dataOptions.sourceOfInformationOptions,
      purchaseItemOptions: dataOptions.purchaseItemOptions,
      occupationOptions: dataOptions.occupationOptions,
      monthlyIncomeOptions: dataOptions.monthlyIncomeOptions,
      relativesPersonOptions: dataOptions.relativesPersonOptions,
      nameProvinceOptions: [],
      nameDistrictOptions: [],
      nameCommuneOptions: [],
      homeTypes: [],
      messageErrorLabels: {
        self: this,
        get name () {
          if (this.self.data.name) {
            return this.self.checkStringLength(this.self.data.name, 'string')
          }
          return this.self.$t('messageError.label.name')
        },
        get last_name () {
          if (this.self.data.last_name) {
            return this.self.checkStringLength(this.self.data.last_name, 'string')
          }
          return this.self.$t('messageError.label.lastname')
        },
        get phone () {
          return this.self.$t('messageError.label.phone')
        },
        get email () {
          const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          const result = re.test(this.self.data.email)
          if (!result && this.self.data.email !== null && this.self.data.email !== '') {
            return this.self.$t('messageError.label.emailInvalid')
          }
          return this.self.$t('messageError.label.email')
        },
        get national_id_number () {
          return this.self.$t('messageError.label.nationalId')
        },
        get amount () {
          return this.self.$t('messageError.label.amount')
        },
        get duration () {
          return this.self.$t('messageError.label.duration')
        },
        get type_of_collateral () {
          return this.self.$t('messageError.label.type_of_collateral')
        },
        get date_of_birth () {
          if (this.self.messageValidateAge) {
            return this.self.$t('borrow.yearForborrow')
          }
          return this.self.$t('messageError.label.Dob')
        },
        get gender () {
          return this.self.$t('messageError.label.gender')
        },
        get marital_status () {
          return this.self.$t('messageError.label.maritalStatus')
        },
        get home_number () {
          return this.self.$t('messageError.label.homeNumber')
        },
        get street_number () {
          return this.self.$t('messageError.label.streetNumber')
        },
        get commune () {
          return this.self.$t('messageError.label.commune')
        },
        get district () {
          return this.self.$t('messageError.label.district')
        },
        get province () {
          return this.self.$t('messageError.label.province')
        },
        get company_name () {
          if (this.self.nameCompany) {
            return this.self.checkStringLength(this.self.nameCompany, 'string')
          }
          return this.self.$t('messageError.label.companyName')
        },
        get gross_monthly_income () {
          return this.self.$t('messageError.label.monthlyIncome')
        },
        get occupation () {
          return 'messageError.label.occupation'
        },
        get company_contact_name () {
          if (this.self.companyContactName) {
            return this.self.checkStringLength(this.self.companyContactName, 'string')
          }
          return this.self.$t('messageError.label.companyContactName')
        },
        get company_contact_phone () {
          return this.self.$t('messageError.label.companyContactPhone')
        },
        get relative_name () {
          if (this.self.relativesName) {
            return this.self.checkStringLength(this.self.relativesName, 'string')
          }
          return this.self.$t('messageError.label.relativeName')
        },
        get relative_contact_phone () {
          return this.self.$t('messageError.label.relativeContact')
        },
        get relative_type () {
          return this.self.$t('messageError.label.relativePerson')
        },
        get borrower_photo () {
          return this.self.$t('messageError.label.photo')
        },
        get borrower_national_id_photo () {
          return this.self.$t('messageError.label.national_id')
        },
        get borrower_employment_card_photo () {
          return this.self.$t('messageError.label.employment_card')
        },
        get source_of_information () {
          return this.self.$t('messageError.label.sourceOfInformation')
        }
      }
    }
  },
  methods: {
    submitFormTabInfo (formName) {
      const self = this
      let data = null
      switch (formName) {
        case 'pawn_choose_product_type':
          let phone_number = null
          if (self.data.phone) {
            phone_number = '855' + self.data.phone.replace(/\s+/g, '').substring(1)
          }

          data = {
            status: self.status,
            formName: formName,
            formType: self.formType,
            type: self.loanType,

            name: this.capitalize(self.data.name),
            last_name: this.capitalize(self.data.last_name),
            phone: phone_number,
            email: self.data.email,
            amount: self.data.amountBorrow,
            duration: self.data.amountDate,
            type_of_collateral: self.typeOfCollateral,
            type_of_collateral_other: self.typeOfCollateral === 'Other' && self.typeOfCollateralOtherValue ? self.typeOfCollateralOtherValue : null
          }
          if (self.id) {
            data.id = self.id
          }
          break
        case 'pawn_personal_information':
          let DOB
          if (self.dateOfBirth && this.messageValidateAge === false) {
            DOB = this.$moment(self.dateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }
          let commune = null
          if (self.commune) commune = self.commune.name_latin
          let district = null
          if (self.district) district = self.district.name_latin
          let province = null
          if (self.province) province = self.province.name_latin
          data = {
            status: self.status,
            formName: formName,
            formType: self.formType,
            id: self.id,
            type: self.loanType,

            date_of_birth: DOB,
            national_id_number: self.IDNumber,
            gender: self.gender,
            marital_status: self.maritalStatus,
            home_number: self.homeNumber,
            street_number: self.streetNumber,
            province: province,
            district: district,
            commune: commune,
            home_type: self.home_type
          }
          break
        case 'pawn_employment_info':
          data = {
            status: self.status,
            formName: formName,
            formType: self.formType,
            id: self.id,
            type: self.loanType,
            occupation: self.occupation,
            company_name: self.nameCompany,
            gross_monthly_income: self.monthlyIncome,
            company_contact_name: self.companyContactName,
            company_contact_phone: this.splitSpace(self.companyContactPhone)
          }
          break
        case 'pawn_relatives_info':
          let has_relative = false
          has_relative = self.havingGuarantor === 'Yes'
          data = {
            status: self.status,
            formName: formName,
            formType: self.formType,
            id: self.id,
            type: self.loanType,
            has_relative: has_relative,
            relative_name: self.relativesName,
            relative_contact_phone: self.relativesContact
          }
          break
        case 'pawn_document_verification':
          data = new FormData()
          data.append('status', 'Pending')
          data.append('formName', formName)
          data.append('formType', self.formType)
          data.append('id', self.id)
          data.append('type', self.loanType)
          data.append('source_of_information', self.sourceOfInformation)
          if (self.sourceOfInformation === 'Other' && self.sourceOfInformationOtherValue) {
            data.append('source_of_information_other', self.sourceOfInformationOtherValue)
          } else {
            data.append('source_of_information_other', null)
          }
          if (self.photo.length > 0 || self.photo) {
            data.append('borrower_photo', self.photo)
          }
          if (self.nationalIdPhoto.length > 0 || self.nationalIdPhoto) {
            data.append('borrower_national_id_photo', self.nationalIdPhoto)
          }
          if (self.employeeCardPhoto.length > 0 || self.employeeCardPhoto) {
            data.append('borrower_employment_card_photo', self.employeeCardPhoto)
          }
          break
      }

      if (this.step === 5) {
        this.$isLoading(true)
        this.messageValidate = ''
        this.$axios.post(this.baseUrl + '/api/v3/frontend/borrow/store', data)
          .then((response) => {
            if (response.data.code === 200) {
              this.id = response.data.data.id
              this.step++
              $(document).scrollTop(0)
              if (this.step === 6) {
                this.data.name = ''
                this.data.last_name = ''
                this.data.phone = ''
                this.data.email = ''
                this.messageValidate = ''
                this.$swal.fire({
                  type: 'success',
                  title: this.$t('messageSuccess.title.submitBorrow'),
                  text: this.$t('messageSuccess.label.submitBorrow'),
                  confirmButtonColor: '#3c56a0',
                  confirmButtonText: this.$t('button.ok')
                })
                // change redirect to home page
                this.$router.push({ name: this.$default_page })
              }
            }
          }).catch((error) => {
            const e = error.response
            if (e.status === 422) {
              this.messageValidate = e.data.errors
              if (typeof this.messageValidate === 'object') {
                this.$swal.fire({
                  type: 'error',
                  title: this.$t('messageError.title.validation'),
                  html: this.generateMessageError(),
                  confirmButtonColor: '#3c56a0',
                  confirmButtonText: this.$t('button.ok')
                })
              } else {
                this.$swal.fire({
                  type: 'error',
                  title: this.$t('messageError.title.serverError'),
                  text: e.data.message,
                  confirmButtonColor: '#3c56a0',
                  confirmButtonText: this.$t('button.ok')
                })
              }
              $(document).scrollTop(0)
            }
          }).finally(() => {
            this.$isLoading(false)
            $(document).scrollTop(0)
          })
      } else {
        this.$isLoading(true)
        this.messageValidate = ''
        this.$axios.post(this.baseUrl + '/api/v3/frontend/borrow/store', data)
          .then((response) => {
            if (response.data.code === 200) {
              this.id = response.data.data.id
              this.step++
              this.messageValidate = ''
            }
          }).catch((error) => {
            const e = error.response
            if (e.status === 422) {
              this.messageValidate = e.data.errors
              if (typeof this.messageValidate === 'object') {
                this.$swal.fire({
                  type: 'error',
                  title: this.$t('messageError.title.validation'),
                  html: this.generateMessageError(),
                  confirmButtonColor: '#3c56a0',
                  confirmButtonText: this.$t('button.ok')
                })
              } else {
                this.$swal.fire({
                  type: 'error',
                  title: this.$t('messageError.title.serverError'),
                  text: e.data.message,
                  confirmButtonColor: '#3c56a0',
                  confirmButtonText: this.$t('button.ok')
                })
              }
              $(document).scrollTop(0)
            }
          }).finally(() => {
            this.$isLoading(false)
            $(document).scrollTop(0)
          })
      }
    },
    capitalize (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    generateMessageError () {
      const generateListItem = (value) => {
        if (value) {
          return '<li>' + this.$t(value) + " <i class='fas fa-times' style='color: var(--danger)'></i></li>"
        } else {
          return ''
        }
      }

      let errorMessage = "<ul class='text-left list-unstyled ml-4 pl-2' style='line-height: 1.5'>"
      if (this.photo && this.messageValidate.hasOwnProperty('borrower_photo')) {
        errorMessage += generateListItem(this.messageValidate.borrower_photo[0])
      } else if (this.nationalIdPhoto && this.messageValidate.hasOwnProperty('borrower_national_id_photo')) {
        errorMessage += generateListItem(this.messageValidate.borrower_national_id_photo[0])
      } else if (this.employeeCardPhoto && this.messageValidate.hasOwnProperty('borrower_employment_card_photo')) {
        errorMessage += generateListItem(this.messageValidate.borrower_employment_card_photo[0])
      } else {
        for (const errorField in this.messageValidate) {
          errorMessage += generateListItem(this.messageErrorLabels[errorField])
        }
      }
      return errorMessage + '</ul>'
    },
    prev () {
      this.messageValidate = ''
      $(document).scrollTop(0)
      this.step--
    },
    splitSpace (string) {
      if (string) {
        return string.split(' ').join('')
      }
    },
    checkStringLength (string, type = null) {
      if (type === 'phone') {
        const length = this.splitSpace(string).length
        if (length < 9) {
          return this.$t('messageError.label.phoneMin')
        } else if (length > 10) {
          return this.$t('messageError.label.phoneMax')
        }
      } else if (type === 'string') {
        const length = string.length
        if (length > 191) {
          return this.$t('messageError.label.stringMax')
        }
      }
    },
    getProvince () {
      this.$axios.get('https://geo-api.asorasoft.com/api/v1/region/options?api_key=ThIsIsKeYfOrCaShHeRo&level=1&selects=name_km,name_latin,code').then((response) => {
        this.nameProvinceOptions = response.data.data
      })
    },
    getDistrict () {
      this.district = null
      this.commune = null
      if (this.province) {
        this.$axios.get(`https://geo-api.asorasoft.com/api/v1/region/options?api_key=ThIsIsKeYfOrCaShHeRo&code=${this.province.code}&selects=name_km,name_latin,code`).then((response) => {
          this.nameDistrictOptions = response.data.data
        })
      }
    },
    getCommune () {
      this.commune = null
      if (this.district) {
        this.$axios.get(`https://geo-api.asorasoft.com/api/v1/region/options?api_key=ThIsIsKeYfOrCaShHeRo&code=${this.district.code}&selects=name_km,name_latin,code`).then((response) => {
          this.nameCommuneOptions = response.data.data
        })
      }
    },
    getLoanValueAndDuration (model, route, code, only_value = false) {
      this.$isLoading(true)
      this.$axios.post(this.$base_api + route)
        .then((response) => {
          if (response.data.code === code && response.data.data !== null) {
            const result = response.data.data
            if (result.min_amount) model.amount.min = result.min_amount
            if (result.max_amount) model.amount.max = result.max_amount
            if (!only_value) {
              if (result.min) model.duration.min = result.min
              if (result.max) model.duration.max = result.max
            }
          }
        }).finally(() => {
          this.$isLoading(false)
        })
    },
    getHomeTypes () {
      this.$axios.get(`${this.baseUrl}/api/v4/frontend/home-types`)
        .then(({ data }) => {
          if (data.data) {
            this.homeTypes = data.data
          }
        })
    }
  },
  mounted () {
    if (this.$route.params.formType) {
      this.formType = this.$route.params.formType
    }
    this.getProvince()
    this.getLoanValueAndDuration(this.pawnData, '/api/v1/interest-rate/pawn/get-interest-rates', 1)
    this.getHomeTypes()
  }
}
</script>

<style scoped>
.img-size {
  width: 60%;
}

.block-img-purchase {
  padding-top: 50px;
  text-align: center;
}

.sample-picture {
  width: 50%;
  margin: 10px 0;
}

@media screen  and (max-width: 991px) {
  .img-size {
    width: 75%
  }
}
</style>
